import { IJackpotDetailsViewModel } from "@/fe-core/meta/interfaces/jackpotDetails";
import {
  GetJackpotDetailsFailureAction,
  GetJackpotDetailsRequestAction,
  GetJackpotDetailsSuccessAction,
  jackpotDetailsActionTypes,
} from "@/fe-core/meta/types/jackpotDetails";
import { IErrorPayload } from "../../meta/interfaces/root";

export const getJackpotDetailsRequest = (): GetJackpotDetailsRequestAction => ({
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_REQUEST,
});

export const getJackpotDetailsSuccess = (
  payload: IJackpotDetailsViewModel
): GetJackpotDetailsSuccessAction => ({
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_SUCCESS,
  payload,
});

export const getJackpotDetailsFailure = (
  payload: IErrorPayload
): GetJackpotDetailsFailureAction => ({
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_FAILURE,
  payload,
});
